const sizes = {
  // 3:4
  portrait_xxl: { w: 1500, h: 2000, fit: 'crop' },
  portrait_xl: { w: 1200, h: 1600, fit: 'crop' },
  portrait_lg: { w: 800, h: 1067, fit: 'crop' },
  portrait_md: { w: 600, h: 800, fit: 'crop' },
  portrait_sm: { w: 450, h: 600, fit: 'crop' },
  portrait_xs: { w: 320, h: 427, fit: 'crop' },
  portrait_xxs: { w: 196, h: 260, fit: 'crop' },

  // 16:10
  landscape_4xl: { w: 2400, h: 1500, fit: 'crop' },
  landscape_3xl: { w: 2000, h: 1250, fit: 'crop' },
  landscape_2xl: { w: 1600, h: 1000, fit: 'crop' },
  landscape_xl: { w: 1200, h: 750, fit: 'crop' },
  landscape_lg: { w: 1000, h: 625, fit: 'crop' },
  landscape_md: { w: 800, h: 500, fit: 'crop' },
  landscape_sm: { w: 600, h: 375, fit: 'crop' },
  landscape_xs: { w: 400, h: 250, fit: 'crop' }
}

function resize(url, options, fm) {
  const params = {
    ...options,
    fm
  }

  if (options.x || options.y) {
    params.crop = 'focalpoint'
    params.fit = 'crop'
    params['fp-x'] = options.x
    params['fp-y'] = options.y
    params['fp-z'] = options.z || 1
  }

  // Extend existing query parameters with new params
  const urlObj = new URL(url)
  const searchParams = new URLSearchParams(urlObj.search)
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) {
      searchParams.set(key, value)
    }
  }
  urlObj.search = searchParams.toString()

  return urlObj.toString()
}

function imgixSize(url, { size, focalPoint }, fm) {
  const sizeConfig = sizes[size]
  const fullConfig = focalPoint?.x || focalPoint?.y ? {
    ...sizeConfig, ...focalPoint
  } : sizeConfig
  return resize(url, fullConfig, fm)
}

export default function useImgix() {
  return { imgixSize }
}
